import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Footer, NegativeCountdownDownload } from "src/app/components";
import { EymemoryRoutes } from "src/app/navigation/routes";
import { getEymemoryOrderDetails } from "src/shared/redux-state/src";
import LocalImages from "../../static";

const DownloadLinkScreen: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialStateRef = useRef(location.state);
  const { startTimer = 5, downloadUrl } = initialStateRef.current || {};
  const { orderHash = "" } = useParams<{ orderHash: string }>();
  
  if (!orderHash) {
    navigate(`${EymemoryRoutes.EYMEMORIES_ERROR}`);
  }

  const orderDetails = useSelector(getEymemoryOrderDetails(orderHash as string));
  
  if (!orderDetails) {
    navigate(
      `${EymemoryRoutes.EYMEMORIES_ERROR}${
        orderHash ? `?orderHash=${orderHash}` : ""
      }`
    );
  }

  return (
    <div className="main-wrapper bg-white container">
      <div className="d-flex flex-column flex-grow-1 mg-b-20 mg-b-xs-50 justify-content-md-center">
        <div className="mg-b-md-30 mg-b-xs-50 mg-t-md-100 mg-t-xs-50 pd-t-xs-0 d-flex justify-content-center flex-column align-items-center">
          <img
            src={LocalImages.eyMemoriesLogo}
            alt="logo"
            className="eymemories-logo"
          />
          <img
            src={LocalImages.eyMemoriesAbstract}
            alt="download icon"
            className="download-icon mg-t-md-30 mg-t-xs-15"
          />
        </div>
        <div className="flex-1 d-flex flex-column justify-content-center align-items-center">
          <NegativeCountdownDownload
            startTimer={startTimer}
            downloadUrl={orderDetails?.meta?.downloadLink || downloadUrl}
            orderHash={orderHash as string}
          />
        </div>
      </div>
      <div className="mg-b-10">
        <Footer />
      </div>
    </div>
  );
};

export default DownloadLinkScreen;
